import { render, staticRenderFns } from "./CustomerProductDiscount.vue?vue&type=template&id=210f3d18&"
import script from "./CustomerProductDiscount.vue?vue&type=script&lang=js&"
export * from "./CustomerProductDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports